"use strict";
/**
 * `@gc/shared` — contracts shared by the API, both web apps, and (mirrored by
 * hand) the .NET agent, print bridge and Android TV agent.
 *
 * Pure TypeScript + zod. No runtime framework dependencies, nothing
 * Node-specific, so the same module runs in NestJS and in the browser.
 *
 *  - `money`        — millidinar arithmetic, proration, rounding rule, IQD formatting
 *  - `business-day` — the Opening/Closing-Time business date and its UTC bounds
 *  - `permissions`  — every permission key and the checks over them
 *  - `events`       — the WebSocket message contracts (the server never dials in)
 *
 * Both flat and namespaced access are supported; prefer the namespace when the
 * bare name would be ambiguous:
 *
 * ```ts
 * import { fromIqd, Money } from '@gc/shared';
 * const total = Money.add(fromIqd(5000), fromIqd(1000));
 * ```
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Reports = exports.Bills = exports.Checkout = exports.Sessions = exports.Devices = exports.Events = exports.Permissions = exports.BusinessDay = exports.Money = void 0;
__exportStar(require("./money"), exports);
__exportStar(require("./business-day"), exports);
__exportStar(require("./permissions"), exports);
__exportStar(require("./events"), exports);
__exportStar(require("./devices"), exports);
__exportStar(require("./checkout"), exports);
__exportStar(require("./outstanding"), exports);
__exportStar(require("./sessions"), exports);
__exportStar(require("./bills"), exports);
__exportStar(require("./reports"), exports);
__exportStar(require("./cafe"), exports);
__exportStar(require("./settings"), exports);
__exportStar(require("./launch-target"), exports);
__exportStar(require("./employees"), exports);
__exportStar(require("./customers"), exports);
__exportStar(require("./box-balance"), exports);
__exportStar(require("./dashboard"), exports);
__exportStar(require("./points"), exports);
__exportStar(require("./finance"), exports);
__exportStar(require("./portal"), exports);
__exportStar(require("./portal-sections"), exports);
__exportStar(require("./portal-pc-preferences"), exports);
exports.Money = __importStar(require("./money"));
exports.BusinessDay = __importStar(require("./business-day"));
exports.Permissions = __importStar(require("./permissions"));
exports.Events = __importStar(require("./events"));
exports.Devices = __importStar(require("./devices"));
exports.Sessions = __importStar(require("./sessions"));
exports.Checkout = __importStar(require("./checkout"));
exports.Bills = __importStar(require("./bills"));
exports.Reports = __importStar(require("./reports"));
__exportStar(require("./engagement"), exports);
__exportStar(require("./shoutouts"), exports);
__exportStar(require("./bookings"), exports);
__exportStar(require("./safe"), exports);
__exportStar(require("./assist"), exports);
__exportStar(require("./recipes"), exports);
__exportStar(require("./app-releases"), exports);
__exportStar(require("./day-passes"), exports);
__exportStar(require("./print-logo"), exports);
__exportStar(require("./audit"), exports);
__exportStar(require("./cash-drawer"), exports);
__exportStar(require("./network"), exports);
__exportStar(require("./venue-code"), exports);
__exportStar(require("./venue-status"), exports);
__exportStar(require("./platform-auth"), exports);
__exportStar(require("./platform-venues"), exports);
__exportStar(require("./app-version"), exports);
//# sourceMappingURL=index.js.map